import { AminPayLogoIcon } from '../../../assets/svg';
import styles from './logo.module.scss';

interface IProps {
  withText?: boolean;
}

export const Logo = ({ withText = false }: IProps): JSX.Element => {
  return (
    <div className={styles.logo}>
      <div className={styles.logoAnimatedIcon}>
        <AminPayLogoIcon />
      </div>
      <div className={styles.logoWithText}>
        <div className={styles.logoRow}>
          <AminPayLogoIcon />
          {withText && (
            <div className={styles.logoWordmark}>
              <span className={styles.amin}>Amin</span>
              <span className={styles.id}>ID</span>
            </div>
          )}
        </div>
        {withText && <div className={styles.logoSubtext}>by AminPay</div>}
      </div>
    </div>
  );
};
